import { IconCheck } from '@tabler/icons-react'

import { SelectAllCaptureBlock as RenderSelectAllCaptureBlock } from '../../templateRenderer/CaptureBlocks/SelectAllCaptureBlock'
import { SelectAllCaptureBlock } from '../../types/blueprint'

import { BaseBlockConfig, Field, TypeOption } from './_BaseBlockConfig'

import { Role } from '@/modules/adminUsers/roles'

class Config extends BaseBlockConfig<SelectAllCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'checkAll' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Select all',
    icon: IconCheck,
    helpText: '(super admin only)',
    roles: [Role.SuperAdmin, Role.BpSuperAdmin],
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: SelectAllCaptureBlock
  ): SelectAllCaptureBlock {
    return block
  }

  public override renderBlock(block: SelectAllCaptureBlock): React.ReactNode {
    return <RenderSelectAllCaptureBlock block={block} />
  }
}

export const CheckAllCaptureBlockConfig = new Config()
